import React, { memo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerCom = ({
    selected,
onChange,
placeholderText
}) => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <div >
      <DatePicker 
       peekNextMonth
        showMonthDropdown
        showYearDropdown
        selected={selected} 
        onChange={onChange} 
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholderText}
      />
    </div>
  );
}

export default memo (DatePickerCom);